var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: 50,
  height: 50
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#7F2A90",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M40.847 18.384c0 12.456-15.569 28.025-15.569 28.025S9.708 30.84 9.708 18.384c0-8.599 6.971-15.569 15.57-15.569s15.569 6.971 15.569 15.569"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25.277,
  cy: 18.384,
  r: 5.19
}))));
export default SvgPin;